module.exports = __webpack_public_path__ + "img/apay-icon-white.4b3641c9.svg";